export default __webpack_public_path__ + "static/media/linkedin.d09d64fe.svg";